export default {
  config: {
    visible: false,
    type: "",
    text: "",
    timeout: -1,
  },
};
